<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2023-07-15 19:09:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-12 15:51:11
-->
<template>
  <CFooter :fixed="false" style="justify-content: center; padding: 0 !important">
    <!-- <div>
      <a href="https://coreui.io" target="_blank">CoreUI</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} creativeLabs.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://coreui.io/vue">CoreUI for Vue</a>
    </div> -->
    <div style="display:flex;flex-direction: column;text-align:center;padding-bottom:1rem">
      <div style="padding-bottom: 5px">
      Copyright © 2020 ~ 2026 Foton Card All rights reserved
    </div>
    <div>
      <!-- 如有疑問請聯係在綫客服或發送電郵至support@fotoncard.com -->
      <span>{{ $t('Footer.EmailLink') }}</span>
      <a href="mailto:support@fotoncard.com" style="color:#3c4b64" target="_blank">support@fotoncard.com</a>
    </div>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
